import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./certificate.css";

const Certificate = () => {
  useEffect(() => {
    AOS.init({
      offset: 0, // Offset (in px) from the original trigger point
      delay: 500, // Delay in milliseconds before animation starts.
      duration: 1000, // Animation duration in milliseconds
      easing: "ease-in-out", // Easing animation
      once: true, // Whether animation should happen only once
      mirror: false, // Whether the AOS should mirror elements when scrolling
    });
  }, []);

  const cer = [
    {
      id: 1,
      path: "./images/cer/img_banner_spec_1.webp",
    },
    {
      id: 2,
      path: "./images/cer/img_banner_spec_2.webp",
    },
    {
      id: 3,
      path: "./images/cer/img_banner_spec_3.webp",
    },
  ];

  return (
    <div className="mb-3 mt-5 border-bottom">
      <div className="d-flex flex-column flex-md-row justify-content-center align-items-center mb-4">
        <img
          data-aos="fade-right"
          className="img-fluid"
          style={{ maxWidth: "8vw", minWidth: "70px" }}
          src="./images/cer/img_title_collection_spec.webp"
          alt="meme"
        />
        <p className="text-uppercase fs-md-3 text-center text-success mt-2 mt-md-0">
          Chứng nhận sản phẩm
        </p>
      </div>
      <div className="cer-wrapper">
        <div className="row">
          {cer.map((prod, i) => (
            <div className="col-12 col-sm-4 col-lg-4" key={prod.id}>
              <img
                className="cer img-fluid mb-3"
                src={prod.path}
                alt={`Certificate ${prod.id}`}
              />
            </div>
          ))}
        </div>
      </div>

      <img
        className="w-100 img-fluid"
        src="./images/cer/home-feature-img.webp"
        alt="meme_feature"
      />
    </div>
  );
};

export default Certificate;
